import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from "next-themes";

// --- Mobile zoom blockers. Scroll and tap are left alone on purpose so
// single-finger scroll works normally. Only multi-touch zoom gestures
// are cancelled. -------------------------------------------------------
if (typeof window !== "undefined") {
  const hasTouch =
    "ontouchstart" in window ||
    window.matchMedia?.("(hover: none) and (pointer: coarse)").matches;

  if (hasTouch) {
    // iOS Safari fires these on pinch. Preventing the start prevents the zoom
    // without interfering with scrolling (which uses touchstart/move/end).
    const block = (e: Event) => e.preventDefault();
    document.addEventListener("gesturestart", block, { passive: false });
    document.addEventListener("gesturechange", block, { passive: false });
    document.addEventListener("gestureend", block, { passive: false });

    // Android/Chromium path: touchstart with 2+ fingers → prevent default
    // on that event only. Single-finger scroll is never affected.
    document.addEventListener(
      "touchstart",
      (e) => {
        if (e.touches && e.touches.length > 1) e.preventDefault();
      },
      { passive: false },
    );
  }
}

// --- Deploy sonrası "eski chunk" kurtarması --------------------------------
// Publish sonrası dosya hash'leri değişir; tarayıcı/SW eski parçayı isteyince
// sunucu 502/404 döner ve lazy sayfa (ör. Admin) BEYAZ kalır. Vite bu durumda
// 'vite:preloadError' fırlatır → taze sürümü çekmek için BİR KEZ yeniden yükle.
if (typeof window !== "undefined") {
  window.addEventListener("vite:preloadError", () => {
    const KEY = "__chunk_reload_at";
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last > 10000) {           // 10 sn içinde tek sefer (döngü yok)
      sessionStorage.setItem(KEY, String(Date.now()));
      window.location.reload();
    }
  });
}

// --- PWA service worker registration -----------------------------------
if ("serviceWorker" in navigator && typeof window !== "undefined") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => console.warn("SW registration failed:", err));
  });
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
      <App />
    </ThemeProvider>
  </HelmetProvider>
);
